<template lang="pug">
feedback-icon(:iconName="iconName")
</template>

<script>
import FeedbackIcon from '@/components/review/general/FeedbackIcon.vue'

export default {
  name: 'FeedbackIconDisplay',
  components: {
    FeedbackIcon,
  },
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['text', 'number', 'date', 'long_text', 'radiobtn', 'checklist', 'email', 'phone', 'address'].includes(value)
      }
    }
  },
  computed: {
    iconName() {
      switch (this.type) {
        case 'text':
          return '$yzi-menu-05'

        case 'phone':
          return '$yzi-phone-02'

        case 'long_text':
          return '$yzi-menu-03'

        case 'radiobtn':
        case 'checklist':
          return '$yzi-dotpoints-02'

        case 'address':
          return '$yzi-markerpin-02'

        case 'email':
          return '$yzi-mail-02'

        case 'date':
          return '$yzi-calendar'

        case 'number':
          return '$yzi-123'

        default:
          return null
      }
    }
  },
}
</script>

<style scoped>
</style>